import { trans } from '@spotahome/soyuz/client';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';
import { useMemo } from 'react';

import LandingSection from '@spotahome/ui-library/src/tenant/components/LandingSection/LandingSection';
import CollapsibleText from '@spotahome/ui-library/src/tenant/components/CollapsibleText/CollapsibleText';
import { useSectionNavigation } from '@spotahome/ui-library/src/tenant/context/SectionNavigationContext';

import itemsToColumns from '../utils/itemsToColumns';

import './AllCities.scss';

const AllCities = ({ cities }) => {
  const citiesColumns = useMemo(() => itemsToColumns(cities, 3), [cities]);

  const { scrollToSection } = useSectionNavigation();

  return (
    <LandingSection className="all-cities">
      <CollapsibleText
        showMoreText={`${trans(
          'landingpage.citylist.label.view_all_cities'
        )} (${cities.length})`}
        showLessText={trans('landingpage.citylist.label.view_less_cities')}
        isCollapsed={false}
        collapsedClassName="all-cities__collapsed"
        showButtonOnTop
        buttonClassName="all-cities__button"
        collapsibleHeight={4}
        contentClassName="all-cities__content"
      >
        {citiesColumns.map((cityColumn, i) => (
          <ul className="all-cities__list" key={`column-${i}`}>
            {cityColumn.map(city => (
              <li key={city.id} className="all-cities__item">
                <span
                  className="all-cities__link"
                  onClick={() => {
                    SoyuzAnalytics.sendGA4Event('send', {
                      section: 'country-all-cities',
                      action: 'click',
                      item_id: city.id
                    });
                    scrollToSection(`city-${city.id}`);
                  }}
                  role="button"
                  tabIndex={0}
                >
                  {city.name}
                </span>
              </li>
            ))}
          </ul>
        ))}
      </CollapsibleText>
    </LandingSection>
  );
};

export default AllCities;
